import { getDefaultRelatedContactDetails } from "@/domain/contactdetails/getContactDetails"
import type { PeopleJsonldReadItemPeople } from "@/networking/api"
import { isNotNullNorUndefined, updateObjectWith } from "@/utils/ts-utils"
import type { Mutable, Optionnal } from "@/utils/types/utils"

export type AddPeopleType = typeof people_gen_props & { fid_cluster?: string }
export type EditPeopleType = Optionnal<AddPeopleType> & { id: string }

export type AddPeopleContacDetailsType = typeof peoplecd_gen_props
export type EditPeopleContacDetailsType = Optionnal<AddPeopleContacDetailsType> & { id: string }

export type AddPeopleFormType = {
  step1: AddPeopleType
  step2: AddPeopleContacDetailsType
}

export type EditPeopleFormType = {
  step1: EditPeopleType
  step2: EditPeopleContacDetailsType
}

export const peoplecd_gen_props = {
  email: "" as string,
  emailFallback: undefined as string | undefined,
  phone: undefined as string | undefined,
  phone2: undefined as string | undefined,
  mobile: "" as string,
  mobile2: undefined as string | undefined,
  address1: undefined as string | undefined,
  address2: undefined as string | undefined,
  address3: undefined as string | undefined,
  city: undefined as string | undefined,
  country: undefined as string | undefined,
  fax: undefined as string | undefined,
  socialFacebook: undefined as string | undefined,
  socialInstagram: undefined as string | undefined,
  socialTwitter: undefined as string | undefined,
  socialLinkedin: undefined as string | undefined,
  socialYoutube: undefined as string | undefined,
  url: undefined as string | undefined,
  zipcode: undefined as string | undefined,
  fid_cluster: undefined as string | undefined,
}

export const people_gen_props = {
  id: undefined as string | undefined,
  fid_cluster: undefined as string | undefined,
  birthdate: undefined as string | undefined,
  birthplace: undefined as string | undefined,
  comment: undefined as string | undefined,
  contactDetails: [{ ...peoplecd_gen_props }] as
    | (AddPeopleContacDetailsType | EditPeopleContacDetailsType)[]
    | undefined,
  contactMethod: undefined as string[] | undefined,
  childCount: undefined as number | undefined,
  firstname: "" as string,
  jobTitle: undefined as string | undefined,
  lastname: "" as string,
  locale: [] as string[],
  maritalStatus: undefined as string | undefined,
  maritalContractStatus: undefined as string | undefined,
  nationality: "" as string,
  taxcode: undefined as string | undefined,
  title: "" as string | undefined,
}

export const getPeopleStep1Data = (people: Mutable<Partial<PeopleJsonldReadItemPeople>>) => {
  return updateObjectWith(
    { ...people_gen_props },
    {
      ...people,
      contactMethod: people.contactMethod
        ?.filter(rel => isNotNullNorUndefined(rel.refLabel))
        .map(rel => rel.refLabel?.code),
      locale: people.locale
        ?.filter(rel => isNotNullNorUndefined(rel.refLabel))
        .map(rel => rel.refLabel?.code),
      maritalStatus: people.maritalStatus?.code,
      maritalContractStatus: people.maritalContractStatus?.code,
      nationality: people.nationality
        ?.filter(rel => isNotNullNorUndefined(rel.refLabel))
        .map(rel => rel.refLabel?.code)
        .shift(),
      title: people.title?.code,
    }
  ) as EditPeopleType
}

export const getPeopleStep2Data = (people: Mutable<Partial<PeopleJsonldReadItemPeople>>) => {
  const contact_details = getDefaultRelatedContactDetails(people.contactDetails)
  return (
    isNotNullNorUndefined(contact_details)
      ? updateObjectWith({ ...peoplecd_gen_props, id: undefined }, contact_details)
      : { ...peoplecd_gen_props }
  ) as EditPeopleContacDetailsType
}
